import { render, staticRenderFns } from "./ProtocoloHistoricoDlg.vue?vue&type=template&id=6e32571d"
import script from "./ProtocoloHistoricoDlg.vue?vue&type=script&lang=js"
export * from "./ProtocoloHistoricoDlg.vue?vue&type=script&lang=js"
import style0 from "./ProtocoloHistoricoDlg.vue?vue&type=style&index=0&id=6e32571d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports